module.exports = __webpack_public_path__ + "static/media/1382_1920.afe78909.jpg";